import { Stack, SxProps, Typography } from "@mui/material";
import RoleGuard from "components/RoleGuard";
import ROLE from "enums/ROLE_NAME";
import { useContext } from "react";
import { getTime } from "utils/display";
import TimelinePlayerContext from "../context/TimelinePlayerContext";
import DownloadVideoButton from "./DownloadVideoButton";
import PlaybackRateButton from "./PlaybackRateButton";
import Scrubber from "./Scrubber";
import ToggleFullscreen from "./ToggleFullscreen";
import TogglePlayPause from "./TogglePlayPause";

interface Props {
  allowDownload?: boolean;
  showControls?: boolean;
  sx?: SxProps;
}

export default function PlayerControls({
  allowDownload = true,
  showControls = true,
  sx,
}: Props) {
  const { absoluteTime, fullscreen, totalDuration } = useContext(
    TimelinePlayerContext,
  );
  const disabled = absoluteTime == undefined;
  return (
    showControls && (
      <Stack
        sx={{
          display: showControls || fullscreen ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          ...sx,
        }}
        direction="row"
        spacing={1}
        onClick={(e) => e.stopPropagation()}
      >
        <TogglePlayPause disabled={disabled} sx={{ zIndex: 1 }} />
        <Scrubber />
        <PlaybackRateButton />
        <ToggleFullscreen disabled={disabled} />
        <RoleGuard disallowedRoles={[ROLE.VIEWER]}>
          {allowDownload && <DownloadVideoButton />}
        </RoleGuard>
        <Typography
          sx={{
            display: disabled ? "hidden" : undefined,
            backgroundColor: "common.black",
            color: "white !important",
            fontWeight: "bold",
            p: ".5rem",
          }}
        >
          {getTime(absoluteTime)}/{getTime(totalDuration)}
        </Typography>
      </Stack>
    )
  );
}
